import React, { PropTypes } from 'react'
import Strings from 'config/strings'

const CreateGameForm = React.createClass({

  propTypes: {
    onSubmit : PropTypes.func.isRequired
  },

  render() {
    return (
      <form className="col" onSubmit={ this.onSubmit }>
        <button className="btn btn--huge block-level--fill fill-blue color-white">
          { Strings['home.start'] }
        </button>
      </form>
    )
  },

  onSubmit(e) {
    e.preventDefault()
    this.props.onSubmit()
  }

})

export default CreateGameForm



/** WEBPACK FOOTER **
 ** ./web/static/app/components/game/create-game-form.jsx
 **/